import { render, staticRenderFns } from "./CheckboxVue.vue?vue&type=template&id=510c0e06&scoped=true&"
import script from "./CheckboxVue.vue?vue&type=script&lang=js&"
export * from "./CheckboxVue.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxVue.vue?vue&type=style&index=0&id=510c0e06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c0e06",
  null
  
)

export default component.exports